const ArticleNumberedList = ({ items, className, startFrom = 1 }) => (
  <div className={`article-numbered-list${className ? ` ${className}` : ''}`}>
    {items.map((item, i) => (
      <div key={i} className="article-numbered-item">
        <span className="article-number-badge" aria-hidden="true">{i + startFrom}</span>
        <span className="body">{item}</span>
      </div>
    ))}
  </div>
);

export default ArticleNumberedList;
